import { useAdministrativeContext } from "../../../../../../../pages/administrativePanel/administrativePanelContext"
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from "recharts"
import { SpaceLoader } from "../../../../../../loaders/spaceLoader"
import { api } from "../../../../../../../services/api"
import { useState, useEffect, useCallback } from "react"
import { toast } from "react-toastify"
import { useAuth } from "../../../../../../../context/AuthContext"


export function CharbacksGraphic() {
    const [chargebackDatas, setChargebackDatas] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    const { signOut } = useAuth()

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()


    const fetchData = useCallback(async () => {
        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }

   
        try{
            await api.post('/getChargeBacksGraphic' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setChargebackDatas(response.data))

            setIsLoading(false)

        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }

      }, [signOut, startDate, endDate, listBusinessToFilter, listSalesChannelsId])


    useEffect(() => {
        let subscribed = true

        if(subscribed && startDate !== '' && endDate !== '')
            fetchData()

        return () => (subscribed = false)
    }, [fetchData, startDate, endDate])


    
    if(isLoading){
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)"/>
    }else{
        return(
            <>
                {
                    chargebackDatas.length > 0 ?
                    <ResponsiveContainer  width="98%" height="100%" maxHeight={700}>
                        <AreaChart  data={chargebackDatas} margin={{top: 35}}>
            
            
                            <Area dataKey="percent"  stroke="#e05f59"  fillOpacity={0} strokeWidth={3}/>
            
            
                            <XAxis dataKey="date" axisLine={false} tickLine={false} stroke="#535354" fontSize="0.55rem"/>
            
                            <YAxis axisLine={false} tickLine={false} tickCount={6} stroke="#535354" padding={{bottom: 10}} fontSize="0.85rem" 
                                
                            />
            
                            <CartesianGrid opacity={0.2} vertical={false} stroke="#535354" />
            
                        </AreaChart>
                    </ResponsiveContainer>
                    :<p>Nenhuma informação</p>
                }
            </>
        )
    }
}
